import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';
import useClinicUser from 'shared/hooks/useClinicUser';
import { CareBenefitUnitOfMeasure } from 'shared/types/graphql';
import { getMonetaryDisplayValue } from 'shared/utils';
import { BenefitUsageData } from './types';

interface BenefitUsageCardBodyProps {
  data: BenefitUsageData;
}

export const BenefitUsageCardBody = ({ data }: BenefitUsageCardBodyProps): JSX.Element => {
  const { currentClinicId } = useClinicUser();
  const { usageClinic, usageUnitOfMeasure, amount } = data;
  return (
    <Box>
      {usageClinic.name && usageClinic.id !== currentClinicId && (
        <Flex alignItems="center" mb={1}>
          <Icon name="locationMarker" size="sm" variant="subtle" />
          <Text variant="subtle" size="sm" ml={1}>
            {usageClinic.name}
          </Text>
        </Flex>
      )}
      <Flex alignItems="center" mb={1}>
        <Icon name="invoice" size="sm" variant="subtle" />
        <Text variant="subtle" size="sm" ml={1}>
          {usageUnitOfMeasure === CareBenefitUnitOfMeasure.Occurence ? 'Total Value: ' : 'Amount Used: '}
          {getMonetaryDisplayValue(amount, true)}
        </Text>
      </Flex>
    </Box>
  );
};
